import React from "react";

export const ExternalConstantsContext = React.createContext([]);
